import React from "react";
import { Query, withApollo } from "react-apollo";

import { Avatar } from './user'
import { Tile, Card } from './chunk'
import { passedTime } from '../date3'
import { ColError, ColLoading } from './chunk'
import { clientCredentials, usersLastAction } from '../graphql/queries';

class Home extends React.Component {

	render() {
		return (
			<div className="fullHeight">
				<div className="container">
					<div className="centered login" style={{textAlign: 'center'}}>
						<Query query={clientCredentials}>
						    {({ loading, error, data : {clientCredentials} }) => {

								if(clientCredentials.id) {
									return (<div className="richtext dist-2">
				      					<div className="avatar avatar--large" style={{backgroundImage: `url(/avatare/${clientCredentials.avatar})`}}></div>
				      					<p>Welcome, {clientCredentials.name}!</p>
				      				</div>);
								  }
								  
								  return null;
							}}
						</Query>

						<Tile>
							<div className="richtext">
								<h2>Zuletzt online</h2>
							</div>
							<Query query={usersLastAction}>
								{({ loading, error, data }) => {

									if( loading ) return (<ColLoading />)
									if( error ) return (<ColError error={error} />)

									if(data && data.usersLastAction) {
										return data.usersLastAction.map(user => {
											const avatar = <Avatar user={user} />;
											return <Card center key={user.id} media={avatar}>
												{passedTime(user.lastAction)}
											</Card>
										})
									} else {
										return null;
									}
								}}
							</Query>
						</Tile>
					</div>
				</div>
			</div>
		);
	}
}

export default withApollo(Home)


// WEBPACK FOOTER //
// ./src/components/Home.js